/*
 * Preload state
 * =============
 */

import assets from '../assets'

export default class Preload extends Phaser.State {

    preload() {
        window.PL = this;
        ARK_game_arena_connector.init();

        setInterval(function () {
            ARK_game_arena_connector.fireEventToArena('event_change')
        }, 1000 * 60 * 4);

        _gameGATracker('create', 'UA-68188765-15', 'auto');
        _gameGATracker('send', 'pageview', {'page': '/LoadingScene'});

        this.bg = this.add.sprite(0, 0, 'preloader', 'preloadBg.png');
        this.bg.anchor.set(0.5);

        this.preloadLogo = this.make.sprite(320 * PARAMS.scaleFactor, 200 * PARAMS.scaleFactor, 'preloader', 'preloadLogo.png');
        this.preloadLogo.anchor.set(0.5);
        this.preloadBg = this.make.sprite(126, 317, 'preloader', 'preloadBarBg.png');
        this.preload = this.make.sprite(126 * PARAMS.scaleFactor, 317 * PARAMS.scaleFactor, 'preloader', 'preloadBar.png');

        this.preloadBg.x = this.preload.x - 10 * PARAMS.scaleFactor;
        this.preloadBg.y = this.preload.y - 8 * PARAMS.scaleFactor;

        this.view = this.add.group();
        this.view.pivot.set(320 * PARAMS.scaleFactor, 240 * PARAMS.scaleFactor);

        var style = {font: '20px Arial', fill: '#000', boundsAlignH: 'center', boundsAlignV: 'middle'};
        this.versionText = this.add.text(4, 4, PARAMS.scaleFactor + ' ' + PARAMS.version, style);

        this.view.add(this.preloadLogo);
        this.view.add(this.preloadBg);
        this.view.add(this.preload);

        this.resize(window.innerWidth, window.innerHeight);

        this.load.setPreloadSprite(this.preload);
        var newAssets = PARAMS.addAtlasesToAssets(assets);
        var newAssets2 = PARAMS.addFontsToAssets(newAssets);
        this.load.pack('game', null, newAssets2)
    }

    create() {
        AUDIO.init(this.game);
        PARAMS.addFontsFromAtlas(this);

        this.time.events.add(100, function () {
            this.state.start('Game')
        }, this)
    }

    // --------------------------------------------------------------------------
    resize(w, h) {
        this.view.x = w / 2;
        this.view.y = h / 2;

        this.bg.x = w / 2;
        this.bg.y = h / 2;

        var scale = Math.min(w / 640, h / 480) / PARAMS.scaleFactor;
        this.view.scale.set(scale * 1.1);

        var bgScale = Math.max(w / 640, h / 480) / PARAMS.scaleFactor;
        this.bg.scale.set(bgScale)
    }
}
